export default __webpack_public_path__ + "72549d9d34ea9a272abc91f7dfb9e6ec.png";